module.exports = __webpack_public_path__ + "img/search.30d6cfba.svg";